<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<p class="P_Norm-Center__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span><span style=" font-style: italic; font-size: 1.00em;">For Allison and Quinn, who are already writing their own stories.</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?648b03a4